// extracted by mini-css-extract-plugin
module.exports = {"list":"aed17b9412--list--XeZ8P","desktop":"aed17b9412--desktop--NPE03","item":"aed17b9412--item--isGhL","phone":"aed17b9412--phone--IUhM0","tablet":"aed17b9412--tablet--MURx9"};